<template>
  <div class="flex-fill">
    <div class="container-main pb-5">
      <div class="py-5 text-center">
        <b-img :src="require('@/assets/images/icon-aircon.svg')"></b-img>
      </div>
      <h1 class="text-center">
        エアコン取付料金<br class="d-md-none" />シミュレータ
      </h1>
      <p class="text-center text-muted h5 font-weight-normal mt-4">
        簡単な質問にお答えいただくだけで、エアコンの取付料金を試算できます。
      </p>
      <b-row no-gutters class="my-5">
        <b-col cols="2" md="3" lg="4">
          <hr class="border-secondary border-2px" />
        </b-col>
        <b-col cols="8" md="6" lg="4">
          <h6
            class="
              h5
              bg-white
              border border-secondary border-2px
              m-0
              py-2
              px-2 px-md-5
              text-muted text-center
            "
            style="border-radius: 20px"
          >
            シミュレーション開始！
          </h6>
        </b-col>
        <b-col cols="2" md="3" lg="4" class="position-relative">
          <hr class="border-secondary border-2px" />
          <b-img
            :src="require('@/assets/images/icon-track.svg')"
            class="position-absolute"
            style="top: -11px; right: 0"
          ></b-img>
        </b-col>
      </b-row>
      <Q_AreaCheck id="Q_AreaCheck" ref="q_AreaCheck" />
      <Q_Removal id="Q_Removal" ref="q_Removal" />
      <Q_Recycling id="Q_Recycling" ref="q_Recycling" />
      <Q_HasConstruction id="Q_HasConstruction" ref="q_HasConstruction" />
      <Q_AirconType id="Q_AirconType" ref="q_AirconType" />
      <Q_HasSocket id="Q_HasSocket" ref="q_HasSocket" />
      <Q_SocketType id="Q_SocketType" ref="q_SocketType" />
      <Q_HasHole id="Q_HasHole" ref="q_HasHole" />
      <Q_HoleType id="Q_HoleType" ref="q_HoleType" />
      <Q_SameFloor id="Q_SameFloor" ref="q_SameFloor" />
      <Q_ExtentionTube id="Q_ExtentionTube" ref="q_ExtentionTube" />
      <Q_UnitType id="Q_UnitType" ref="q_UnitType" />
      <Q_UnitFloor id="Q_UnitFloor" ref="q_UnitFloor" />
      <Price id="q13" ref="price" @continueSimulation="continueSimulation" />
      <div style="height: 500px"></div>
    </div>
  </div>
</template>

<script>
import Q_AreaCheck from "./questions/Q_AreaCheck";
import Q_Removal from "./questions/Q_Removal";
import Q_Recycling from "./questions/Q_Recycling";
import Q_HasConstruction from "./questions/Q_HasConstruction";
import Q_AirconType from "./questions/Q_AirconType";
import Q_HasSocket from "./questions/Q_HasSocket";
import Q_SocketType from "./questions/Q_SocketType";
import Q_HasHole from "./questions/Q_HasHole";
import Q_ExtentionTube from "./questions/Q_ExtentionTube";
import Q_SameFloor from "./questions/Q_SameFloor";
import Q_HoleType from "./questions/Q_HoleType";
import Q_UnitType from "./questions/Q_UnitType";
import Q_UnitFloor from "./questions/Q_UnitFloor";
import Price from "./questions/Price";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    Q_AreaCheck,
    Q_Removal,
    Q_Recycling,
    Q_HasConstruction,
    Q_AirconType,
    Q_HasSocket,
    Q_SocketType,
    Q_HasHole,
    Q_ExtentionTube,
    Q_SameFloor,
    Q_HoleType,
    Q_UnitType,
    Q_UnitFloor,
    Price,
  },

  data() {
    return {};
  },
  mounted() {
    // カレンダーデータを取得する
    this.readCalendar();
  },
  watch: {
    maxStep(val, old) {
      if (val - old == 1) {
        // スクロール
        this.goto(val);
      } else if (val == 7 && old == 5) {
        // スクロール
        setTimeout(() => {
          this.goto(val);
        }, 200);
      }
    },
  },
  computed: {
    ...mapState({
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
  },
  methods: {
    goto(step) {
      console.log(step);
      // window.scrollTo({
      //   top: document.getElementById("q" + (step - 1)).offsetTop - 60,
      //   left: 0,
      //   behavior: "smooth",
      // });
    },
    // step2に巻き戻し
    continueSimulation() {
      this.$refs.q_Removal.reset();
      this.$refs.q_Recycling.reset();
      this.$refs.q_HasConstruction.reset();
      this.$refs.q_AirconType.reset();
      this.$refs.q_HasSocket.reset();
      this.$refs.q_SocketType.reset();
      this.$refs.q_HasHole.reset();
      this.$refs.q_ExtentionTube.reset();
      this.$refs.q_SameFloor.reset();
      this.$refs.q_HoleType.reset();
      this.$refs.q_UnitType.reset();
      this.$refs.q_UnitFloor.reset();
      this.$refs.price.reset();
      // スクロール
      window.scrollTo({
        top: 300,
        left: 0,
        behavior: "smooth",
      });
    },
    ...mapActions({
      doSaveCalendars: "doSaveCalendars",
    }),
    //カレンダー読み込み
    readCalendar() {
      console.log("カレンダー読込");
      //カレンダー読込
      // const url = "./functions/dummy.json";
      const url =
        "https://aircon-hanbai.jp/simulator-web/functions/calendar/read.php";
      this.axios
        .get(url)
        .then((res) => {
          console.log("カレンダー読込成功");
          if (res.data == false || res.data == "" || res.data == "false") {
            console.log("空", res.data);
          } else {
            console.log("有効", res.data);
            this.doSaveCalendars(JSON.parse(res.data));
            // this.doSaveCalendars(res.data);
          }
        })
        .catch((err) => {
          console.log("カレンダー読込エラー");
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>